import Postbox from './Postbox.vue';
export default {
  Postbox,
};
